/**
 * Returned by a `getCustom*FieldMessage` builder when a change should render no row at all —
 * either another change of the same activity already covers it, or the activity carries its own
 * dedicated message.
 *
 * A plain `null` cannot say this: the `build*Message` callers treat every falsy custom message as
 * "no custom copy" and fall back to the generic `changed the <field> from A to B` sentence, and a
 * builder's `default: return null` would otherwise suppress every field it does not handle.
 */
export const SUPPRESS_ACTIVITY_ROW = Symbol('suppressActivityRow');
